import iconMarkerGetter from '@/services/general/map/iconMarkerGetter';
import { HEIGHT_LOGO_ICON, WIDTH_LOGO_ICON } from '@/configuration/general/iconMarkerConf';
import getDataUrl from '@/services/general/map/urlToIcon';

export default function markersGetter(adresse, color, azimut, tabMarkers) {
  let markers = [];

  if (tabMarkers) markers = tabMarkers;
  let icon = { url: '/static/img/gabed/emplacement/markerGoogleMapEmplacement.png' };
  if (color) icon = iconMarkerGetter(color, azimut);
  markers.push({
    position: {
      lat: adresse.latitude === undefined ? adresse.lat : Number(adresse.latitude),
      lng: adresse.longitude === undefined ? adresse.lng : Number(adresse.longitude),
    },
    icon: icon,
  });
  return markers;
}

export function markGetter(adresse, color, azimut, url) {
  return new Promise((resolve, reject) => {
    if (!adresse) reject();
    const mark = {};
    mark.position = {
      lat: adresse.latitude === undefined ? adresse.lat : Number(adresse.latitude),
      lng: adresse.longitude === undefined ? adresse.lng : Number(adresse.longitude),
    };
    if (url) {
      const img = document.createElement('img');
      img.setAttribute('src', url);
      img.setAttribute('crossOrigin', 'Anonymous');
      img.onload = () => {
        const dataUrl = getDataUrl(img);
        mark.icon = {
          url: dataUrl,
          scaledSize: new google.maps.Size(WIDTH_LOGO_ICON, HEIGHT_LOGO_ICON),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(WIDTH_LOGO_ICON / 2, HEIGHT_LOGO_ICON),
        };
        resolve(mark);
      };
    } else if (color) {
      mark.icon = iconMarkerGetter(color, azimut);
      resolve(mark);
    } else {
      mark.icon = { url: '/static/img/gabed/emplacement/markerGoogleMapEmplacement.png' };
      resolve(mark);
    }
  });
}
